import { withEl } from "@front/utils";
import { createComponent } from "@front/utils/alpine";

export type Review = {
    date: string;
    feedback: string;
    nickname: string;
    rating: number;
};

export default createComponent(() => ({
    container: document.querySelector('.js-ekomi-wrapper') as HTMLElement,
    btn: document.querySelector('.js-ekomi-btn') as HTMLElement,
    count: 0 as number,
    hiddenReviews: [] as Array<Review>,
    
    init() {
        withEl(this.$refs.meta, el => {
            const data = el.getAttribute('content') as string;
            this.hiddenReviews = JSON.parse(data);
        });
    },

    showMore() {
        this.count++;
        const toShow = [] as Array<Review>;

        this.hiddenReviews.forEach((item, index) => {
            if (this.count == 1 && index < this.count*5) {
                toShow.push(item);
            } else if (this.count > 1 && (index >= this.count*5 - 5 && index < this.count*5)){
                toShow.push(item);
            }
        });

        if(this.hiddenReviews.at(-1) == toShow.at(-1)) {
            this.btn.classList.add('hidden');
        }

        toShow.forEach((item) => {
            !item.nickname ? item.nickname = 'Anonyme' : '';

            item.date.indexOf(':') > -1 ? item.date = new Date(item.date).toLocaleDateString() : '';

            let filled = '' as String,
                notFilled = '' as String;

            for(let i = 0; i < 5; i++) {
                if(item.rating > i) {
                    filled += '<i class="fas fa-star text-yellow h-5 w-5"></i>';
                } else {
                    notFilled += '<i class="far fa-star text-yellow h-5 w-5"></i>';
                }
            }

            const element = `
            <article class="flex flex-col p-6 mt-4 w-full bg-white max-md:px-5 max-md:max-w-full">
                <div class="flex flex-wrap gap-10 justify-between items-start w-full max-md:max-w-full">
                    <div class="flex flex-col w-24 whitespace-nowrap">
                        <h5 class="text-base font-bold tracking-normal leading-none text-black mb-2">${this.escapeHtml(item.nickname)}</h5>
                        <time class="text-sm leading-none text-neutral-600">${item.date}</time>
                    </div>
                    <div class="flex items-center w-24">
                        ${filled}
                        ${notFilled}
                    </div>
                </div>
                <div class="mt-2 text-base text-black max-md:max-w-full">${this.escapeHtml(item.feedback)}</div>
            </article>
            `;

            this.container.insertAdjacentHTML('beforeend', element);
        })
    },

    escapeHtml(unsafe: string) {
        return unsafe.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
    },
}));